<template v-if="show">
  <pe-modal ref="modal" :header="title" width="1138px">
    <div class="mt-8">
      <pe-input-search v-model="searchTerm" :placeholder="$t('placeholder.search')" class="mx-4 mb-6" />

      <pe-table
        class="mb-9"
        ref="tableRef"
        :selectable="!previewMode"
        :selection-type="multiple ? 'multiple' : 'single'"
        rowIndex="id"
        :columns="columns"
        :data="rows"
        :searchTerm="searchTerm"
        :default-filters="{ active: [true] }"
        :loading="loading"
        @selectionChange="onSelectionChange"
      />
    </div>

    <template #footer>
      <div class="flex flex-wrap gap-2 py-2 justify-end">
        <UiButton v-if="previewMode" type="primary" outline class="p-3 uppercase" @click="() => cancel()">{{ $t('button.back') }}</UiButton>
        <UiButton v-if="!previewMode" type="primary" outline class="p-3 uppercase" @click="() => cancel()">{{ $t('button.cancel') }}</UiButton>
        <UiButton v-if="!previewMode" type="primary" :disabled="isDisabled" class="p-3 uppercase" @click="() => confirm()">{{ $t('button.confirm') }}</UiButton>
      </div>
    </template>
  </pe-modal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

import UiButton from '@/components/ui/button.vue'

import type { TableColumnsType } from '@/types/types'

const props = defineProps<{
  title: string
  width?: string | number
  multiple?: boolean
  columns?: TableColumnsType[]
  data?: any[]
  selected?: any
  returnData?: boolean // Se deve retornar os objetos selecionado ou apenas os IDs
  loading?: boolean
  previewMode?: boolean
  onAfterOpen?: () => void | boolean | Promise<void | boolean>
}>()

const emit = defineEmits(['onComplete'])

const tableRef = ref()
const searchTerm = ref('')
const modal = ref()
const rows = ref([])
const selectedIndex = ref<any | any[]>()
const isDisabled = computed(() => (props.multiple ? !selectedIndex.value?.length : !selectedIndex.value))

const onSelectionChange = (value: any | any[]) => {
  selectedIndex.value = value
}

const open = async (selected: any) => {
  await modal.value?.open()
  searchTerm.value = ''

  if (typeof props.onAfterOpen === 'function') {
    props.onAfterOpen()
      .then(() => {
        rows.value = props.data.filter(el => Array.isArray(selected) ? !selected.includes(el.id) : true)
      })
      .catch(() => {
      })
  } else {
    rows.value = props.data.filter(el => Array.isArray(selected) ? !selected.includes(el.id) : true)
  }

  if (typeof selected !== 'undefined') {
    tableRef.value?.setSelection(selected)
    selectedIndex.value = selected
  }
}

const cancel = () => {
  emit('onComplete', false)
  modal.value?.cancel()
}

const confirm = () => {
  if (props.returnData)
    emit(
      'onComplete',
      props.multiple
        ? props.data?.filter((el) => selectedIndex.value.includes(el.id))
        : props.data?.find((el) => el.id === selectedIndex.value)
    )
  else emit('onComplete', selectedIndex.value)
  modal.value?.cancel()
}

defineExpose({
  open,
  cancel,
  confirm
})
</script>
